import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import * as React from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import { useState } from "react";
import { Chart } from "react-google-charts";
import { storesByProvinceId } from "rest/requests";
import { countStoresByProvince } from "rest/requests";
import DetailsDialogStores from "./DetailsDialog";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function CatastroMapaAlmacenes() {
  const [storesByProvince, setStoresByProvince] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [wating, setWaiting] = React.useState(false);

  const getAllStoresSummary = useCallback(async () => {
    setStoresByProvince(await countStoresByProvince());
  }, []);

  useEffect(() => {
    getAllStoresSummary();
  }, []);

  const [provData, setProvData] = useState([]);

  useEffect(() => {
    const mappedStores = storesByProvince.map((store) => {
      if (store[1].toUpperCase().includes("ZAMORA") || store[1].toUpperCase().includes("MORONA")) {
        store.push(store[1].replace(" ", "-"));
        return [store[1].replace(" ", "-"), store[3]];
      }
      if (store[1].toUpperCase().includes("ELENA")) {
        store.push("EC-SE");
        return ["EC-SE", store[3]];
      }
      if (store[1].toUpperCase().includes("DOMINGO")) {
        store.push("EC-SD");
        return ["EC-SD", store[3]];
      }
      store.push(store[1]);
      return [store[1], store[3]];
    });
    const _data = [["Provincia", "Almacenes"]].concat(mappedStores);
    setProvData(_data);
  }, [storesByProvince]);

  const [selectedProvince, setSelectedProvince] = useState(null);
  const [stores, setStores] = useState([]);

  const options = {
    region: "EC",
    resolution: "provinces",
    colors: ["orange", "yellow", "green", "blue", "lightblue", "pink"],
    displayMode: "regions",
    backgroundColor: "#81d4fa",
  };

  const getStoresByProvince = useCallback(async () => {
    if (selectedProvince) {
      console.log("Selected Province: ", selectedProvince);
      setWaiting(true);
      setStores(await storesByProvinceId(selectedProvince));
      setWaiting(false);
    }
  }, [selectedProvince]);

  useEffect(() => {
    getStoresByProvince();
  }, [selectedProvince]);

  useEffect(() => {
    if (stores.length > 0) {
      setModalOpen(true);
    }
  }, [stores]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div justify-content="center">
        {storesByProvince.length > 0 ? (
          <Chart
            chartType="GeoChart"
            width="100%"
            data={provData}
            options={options}
            chartEvents={[
              {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                  const chart = chartWrapper.getChart();
                  const selection = chart.getSelection();
                  if (selection.length === 0) return;
                  const region = provData[selection[0].row + 1];
                  console.log("Selected : " + region);

                  const provinceCode = storesByProvince.filter((store) => {
                    return store[4] === region[0];
                  });
                  if (provinceCode && provinceCode[0] && provinceCode[0].length > 0) {
                    setSelectedProvince(provinceCode[0][2]);
                  } else {
                    setSelectedProvince(null);
                  }
                },
              },
            ]}
          />
        ) : (
          <></>
        )}
      </div>
      {modalOpen ? (
        <>
          <DetailsDialogStores
            open={modalOpen}
            setOpen={setModalOpen}
            modalData={stores}
            setModalData={setStores}
          ></DetailsDialogStores>
        </>
      ) : (
        ""
      )}

      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={wating}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Footer />
    </DashboardLayout>
  );
}

export default CatastroMapaAlmacenes;
